var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath1045(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "127.95pt",
    height: "77.305pt",
    viewBox: "0 0 127.95 77.305",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.637 31.48h70.867v-2.8203h-70.867z",
    fill: "#244aa5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0.24999 71.383c0 3.1328 2.5391 5.6719 5.668 5.6719h116.11c3.1328 0 5.6719-2.5391 5.6719-5.6719v-65.465c0-3.1328-2.5391-5.668-5.6719-5.668h-116.11c-3.1289 0-5.668 2.5351-5.668 5.668z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.957 50.125h76.535v-22.68h-76.535z",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1045);
export default __webpack_public_path__ + "static/media/path1045.3d51125007f762c8f53b3fd22dc041b7.svg";
export { ForwardRef as ReactComponent };